/**
 * SHA-256 of a file as lowercase hex — the shape the API's `sha256` transfer check takes. Computed
 * in the browser so every manual submission gets transfer integrity without the user knowing the
 * field exists.
 */
export async function sha256Hex(file: File): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', await file.arrayBuffer());
  return [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, '0')).join('');
}
